import React, { Component, Context } from "react";
import { RouteComponentProps, withRouter } from "react-router-dom";
import { connect } from "react-redux";
import * as firebase from "firebase/app";
import { IPeerSupportActionDispatches, mapPeerSupportDispatchToProps } from "../../redux/actions/peerSupport";
import { IPeerSupportState, mapPeerSupportStateToProps } from "../../redux/reducers/peerSupport";
import Grid from "../grid";
import { ColDef } from "ag-grid-community";
import { getForm } from "../../laco-common/base/firestore-utils";
import { IForm } from "../../laco-common";
import { getColDefsFromForm } from "../grid/columns/utils";

type AdminMonthlyReportsState = {
	loading: boolean;
	columnDefs: ColDef[];
};

class AdminMonthlyReports extends Component<
	IPeerSupportActionDispatches & IPeerSupportState & RouteComponentProps,
	AdminMonthlyReportsState
> {
	state = {
		loading: true,
		searchQuery: "",
		columnDefs: [],
	};

	async componentDidMount() {
		const formConfig: IForm = await getForm("peer-support-monthly", firebase.app());
		const columnDefs: ColDef[] = getColDefsFromForm(formConfig);
		this.loadReports().then(() => {
			this.setState({ loading: false, columnDefs });
		});
	}

	async loadReports(): Promise<any> {
		return this.props.loadMonthlyReports();
	}

	render() {
		console.debug("reports:", this.props.reports);

		// const isAdmin: boolean =
		// context.userPayload.superAdmin ||
		// (context.tenant === "pili-mobile" &&
		// 	(context.userPayload.psAdmin || context.userPayload.psRole === "admin")) ||
		// (context.tenant !== "pili-mobile" && context.userPayload.role === "admin"); // TODO: gary handle team role

		return (
			<div className="container my-4 pb-2">
				<Grid
					displayTitle
					columnDefs={this.state.columnDefs}
					rowData={this.props.reports}
					loading={this.state.loading}
					onRefresh={this.loadReports.bind(this)}
					withUserCols={true}
					exportFilename="Monthly Reports"
					noDataMsg="No Monthly Reports"
					entityName="Monthly Reports"
					isAdmin={true}
				/>
			</div>
		);
	}
}

export default connect<IPeerSupportState, IPeerSupportActionDispatches>(
	mapPeerSupportStateToProps,
	mapPeerSupportDispatchToProps
)(withRouter(AdminMonthlyReports));
